import React from 'react';
import LinearProgress from 'material-ui/LinearProgress';


const LinearProgressExampleSimple = () => (
  <LinearProgress mode="indeterminate" />
);

export default LinearProgressExampleSimple;


// WEBPACK FOOTER //
// ./src/Load.js